import {Box} from "@chakra-ui/react"
import "../../../styles/area.css"
import {VersionSelector} from "../versions/VersionSelector";
import {AreaStatistics} from "../../components/types";

type Props = {
    statistics?: AreaStatistics
}

export const AreaTools = ({}: Props) => {
    return <Box width={"100%"} display={"flex"} alignItems={"center"} minHeight={0}>
        <VersionSelector/>
    </Box>
}
